import PurchaseOrders from './PurchaseOrders.container';

export default PurchaseOrders;